'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * DropdownList component, used to display a list of items in the Dropdown.
 *
 * @example
 * <Dropdown>
 *  <DropdownList>
 *    <DropdownItem>
 *      <DropdownButton>Button</DropdownButton>
 *    </DropdownItem>
 *  </DropdownList>
 * </Dropdown>
 */
const DropdownList = forwardRef(function DropdownList(rest, ref) {
    return jsx("ul", { ref: ref, ...rest });
});

export { DropdownList };
